import React, { useEffect, useState, useContext } from "react";
import URLstateContext from "../../provider/CommonContext";
import { Col, Container, Row } from "react-bootstrap";
import "./AboutUs.css";
import { useNavigate } from "react-router-dom";
import Vision from "./Vision/Vision";
import Values from "./Values/Values";
import AMCNew from "./AMCNew/AMCNew";
import JMFinancials from "./JMFinancials/JMFinancials";
import Trustee from "./Trustee/Trustee";
import Sponsor from "./Sponsor/Sponsor";
import Amc from "./AMC/Amc";
import Auditor from "./Auditor/Auditor";
import Custodian from "./Custodian/Custodian";
import CompanyDetail from "./CompanyDetail/CompanyDetail";
import AboutBanner from "./AboutBanner/AboutBanner";
import CorporateProfile from "./CorporateProfile/CorporateProfile";
import ExecutiveRemuneration from "./CorporateProfile/ExecutiveRemuneration";
import Managment from "./Managment/Managment";
import Registar from "./Registar/Registar";
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { trackEvent, trackPageView } from "../utils/tracking";
import { Helmet, HelmetProvider } from "react-helmet-async";
import CorporatePresentation from "./CorporatePresentation/CorporatePresentation";
function AboutUs() {
  const [value, setValue] = React.useState(1);
  const [pathname, setPathName] = useState("");
  const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
    useContext(URLstateContext);
  useEffect(() => {
    const pathname = decodeURIComponent(window.location.pathname);
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });

  useEffect(() => {
    trackPageView("https://www.jmfinancialmf.com/AboutUs", "jmf_about-us");
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Static Page",
      action: "AboutUs Page Loaded",
      label: "jmf_about-us",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    const buttons = document.querySelectorAll(".MuiTabScrollButton-root");

    if (buttons.length >= 2) {
        buttons[0].setAttribute("aria-label", "Previous tabs");
        buttons[1].setAttribute("aria-label", "Next tabs");
    }
}, []);

  const arrayOfTabsObj = [
    // { name: "Vision", id: 1},
    { name: "What-We-Stand-For", id: 1 },
    { name: "JM-Financial", id: 2 },
    { name: "AMC", id: 10 },
    {name: "Corporate-Presentation", id:11},
    { name: "Teams", id: 3 },
    { name: "Trustee-Board", id: 4 },
    { name: "AMC-Board", id: 5 },
    // { name: "Sponsor", id: 6 },
    // { name: "Auditor", id: 7 },
    // { name: "Custodian", id: 8 },
    // { name: "Registrars", id: 9 },
  ];
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const selectedTab = arrayOfTabsObj.find((tab) => tab.id === newValue);
    navigate(`/AboutUs/${selectedTab.name.replace(/\s+/g, " ")}`);
  };
  useEffect(() => {
    var para = window.location.pathname.toLocaleLowerCase().split("/")[2];
    if (para === "teams") setValue(3);
    if (para === "amc-board") setValue(5);
    if (para === "trustee-board") setValue(4);
    if (para === "sponsor") setValue(6);
    if (para === "auditors") setValue(7);
    if (para === "custodian") setValue(8);
    if (para === "registrar") setValue(9);
    if (para === "jm-financial") setValue(2);
    if(para === "corporate-presentation") setValue(11);
    if (para === "amc") setValue(10);
  }, []);

  function capitalizeWords(str) {
    return str.replace(/\b\w/g, (match) => match.toUpperCase());
  }
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Discover the legacy and expertise of JM Financial Mutual Fund. With decades of experience, we aim to deliver innovative wealth management solutions tailored to investor needs."
          />
          <title>About Us | Learn More About JM Financial Mutual Fund</title>
        </Helmet>
      </HelmetProvider>

      <AboutBanner id={value} />
      <main id="main-content" tabIndex="-1">
      <section
        className="download-detail about-detail"
        style={{ fontSize: `${fontSize}px` }}
      >
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i className="fa fa-home" aria-hidden="true"></i>
                    <span className="sr-only"> Home</span>
                  </a>{" "}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/AboutUs">
                    About Us
                  </a>{" "}
                  <i className="fa fa-angle-right"></i>
                </li>
                {/* <li>Calculator</li><i className="fa fa-angle-right" aria-hidden="true"></i> */}
                {window.location.pathname !== "/AboutUs" ? (
                  <li>
                    {decodeURIComponent(
                      capitalizeWords(
                        pathname.replace(/([a-z])([A-Z])/g, "$1 $2")
                      ).replace(/-/g, " ")
                    )}
                  </li>
                ) : (
                  <li>What We Stand For</li>
                )}
              </ul>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col sm={12}>
              <Box sx={{ width: "100%" }}>
                <TabContext value={value}>
                  <Box
                    sx={{
                      borderBottom: 0,
                      borderColor: "divider",
                      bgcolor: "background.paper",
                    }}
                  >
                    {/*  */}
                    <TabList
                      onChange={handleChange}
                      variant="scrollable"
                      sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                      }}
                      scrollButtons="auto"
                      slotProps={{
                          startScrollButtonIcon: {
                              "aria-hidden": true
                          },
                          endScrollButtonIcon: {
                              "aria-hidden": true
                          }
                      }}
                                          >
                      {arrayOfTabsObj.map((item) => (
                        <Tab
                          className={item.id === 3 ? "width185" : "width125"}
                          label={item.name.replace(/-/g, " ")}
                          value={item.id}
                          disableFocusRipple
                        ></Tab>
                      ))}
                    </TabList>
                  </Box>
                  {/* <TabPanel value={1}>                         
                         <Vision></Vision>
                    </TabPanel> */}
                  <TabPanel value={1}>
                    <Values></Values>
                  </TabPanel>

                  <TabPanel value={2}>
                    <JMFinancials></JMFinancials>
                  </TabPanel>
                  <TabPanel value={10}>
                    <AMCNew></AMCNew>
                  </TabPanel>

                  <TabPanel value={3}>
                    <CorporateProfile></CorporateProfile>
                  </TabPanel>
                  <TabPanel value={4}>
                    <Trustee></Trustee>
                  </TabPanel>
                  <TabPanel value={5}>
                    <Amc></Amc>
                  </TabPanel>
                  <TabPanel value={11}>
                      <CorporatePresentation></CorporatePresentation>
                  </TabPanel>
                  {/* <Sponsor/> */}
                  {/* <TabPanel value={6}>
                         <Sponsor></Sponsor>
                    </TabPanel>
                    <TabPanel value={7}>
                         <Auditor></Auditor>
                    </TabPanel>
                    <TabPanel value={8}>
                         <Custodian></Custodian>
                    </TabPanel>
                    <TabPanel value={9}>
                         <Registar></Registar>
                    </TabPanel> */}
                  {/* <TabPanel value={10}>
                         <CompanyDetail></CompanyDetail>
                    </TabPanel> */}
                </TabContext>
              </Box>
            </Col>
          </Row>
        </Container>
      </section>

      </main>

    </>
  );
}

export default AboutUs;
